/* eslint-disable max-classes-per-file */
import { EntitiesList, EntitiesListsManager } from './entitiesLists';

class BrandsList extends EntitiesList {
  loadItems() {
    return this.getBrands();
  }
  loadMoreItems() {
    return this.getBrands();
  }
  getBrands() {
    return this.appAPI.brands(
      this.currentPage,
      this.itemsPerPage,
      this.searchQuery,
    );
  }
  formatResponse(response) {
    const {
      pagination,
      customer_accounts: customerAccounts,
    } = response;
    return {
      total: pagination.total,
      items: customerAccounts.map((brand) => this.entitiesFormatter.brand(brand)),
    };
  }
}

export default class BrandsListsManager extends EntitiesListsManager {
  getEntitiesListClass() {
    return BrandsList;
  }
}
